<template>
	<div>
		<ImageModal
			v-if="shouldShow"
			@close="onClose"
			:imageUrl="urls.image"
			:videoUrl="urls.video"
			:pdfUrl="urls.pdf"
			:mediaItems="urls.mediaItems"
			:mediaId="urls.mediaId"
			:downloadName="downloadDetails.name"
			@update:imageUrl="updateImageUrl"
			@update:videoUrl="updateVideoUrl"
		/>
	</div>
</template>

<script>
import { reactive } from 'vue'
import ImageModal from './ImageModal'
import { getMessage } from '@/store'

const downloadDetails = reactive({ name: null })
const urls = reactive({
	image: null,
	video: null,
	pdf: null,
	mediaItems: null,
	mediaId: null,
})

export const modal = {
	image(url, name) {
		modal.close()
		urls.image = url
		downloadDetails.name = name
	},
	video(url, name) {
		modal.close()
		urls.video = url
		downloadDetails.name = name
	},
	pdf(url, name) {
		modal.close()
		urls.pdf = url
		downloadDetails.name = name
	},
	message(messageOrId, mediaId) {
		// messageOrId can be a message ID or a message object
		const message = Number.isInteger(messageOrId)
			? getMessage(messageOrId)
			: messageOrId
		if (!message?.messagemedia?.length) return
		urls.mediaItems = message.messagemedia
		urls.mediaId = mediaId
	},
	mediaItems(items, mediaId) {
		urls.mediaItems = items
		urls.mediaId = mediaId
	},
	close() {
		Object.keys(urls).forEach((key) => {
			urls[key] = null
		})
	},
}

export function useMediaModal() {
	return modal
}

export const MediaModalPlugin = {
	install: function (app) {
		Object.assign(app.config.globalProperties, {
			$imageModal: (url, downloadName) => {
				modal.image(url, downloadName)
			},
			$videoModal: (url, downloadName) => {
				modal.video(url, downloadName)
			},
			$messageId: (id) => {
				modal.message(id)
			},
			$mediaItems: (items, startId) => {
				modal.mediaItems(items, startId)
			},
			$closeModal: () => {
				modal.close()
			},
		})
	},
}

export default {
	name: 'MediaModal',
	components: { ImageModal },
	data() {
		return {
			urls,
			downloadDetails,
		}
	},

	computed: {
		shouldShow() {
			return Object.values(urls).some((value) => !!value)
		},
	},

	methods: {
		onClose() {
			modal.close()
		},
		updateImageUrl(newUrl) {
			this.urls.video = null
			this.urls.image = newUrl
		},
		updateVideoUrl(newUrl) {
			this.urls.image = null
			this.urls.video = newUrl
		},
	},
}
</script>

<style lang="scss" scoped></style>
